// Generated file, changes will eventually be overwritten!
import { Talent } from './types';

const talents = {
  AGAINST_ALL_ODDS_TALENT: {
    id: 450986,
    name: 'Against All Odds',
    icon: 'achievement_legionpvp6tier1',
    maxRanks: 1,
    entryIds: [125074],
    definitionIds: [{ id: 129906, specId: 269 }],
  },
  AIRBORNE_RHYTHM_TALENT: {
    id: 1248833,
    name: 'Airborne Rhythm',
    icon: 'inv_tradeskillitem_sorcererswind_tong',
    maxRanks: 1,
    entryIds: [124815],
    definitionIds: [{ id: 129653, specId: 269 }],
  },
  AMPLIFIED_RUSH_TALENT: {
    id: 1271431,
    name: 'Amplified Rush',
    icon: 'ability_monk_rushingjadewind',
    maxRanks: 1,
    entryIds: [124884],
    definitionIds: [{ id: 129722, specId: 270 }],
  },
  ANCIENT_ARTS_TALENT: {
    id: 344359,
    name: 'Ancient Arts',
    icon: 'ability_monk_dpsstance',
    maxRanks: 2,
    entryIds: [124983],
    definitionIds: [{ id: 129821, specId: 270 }],
  },
  ANVIL_AND_STAVE_TALENT: {
    id: 386937,
    name: 'Anvil and Stave',
    icon: 'ability_monk_elusiveale',
    maxRanks: 2,
    entryIds: [124856],
    definitionIds: [{ id: 129694, specId: 268 }],
  },
  ASCENSION_TALENT: {
    id: 115396,
    name: 'Ascension',
    icon: 'ability_monk_ascension',
    maxRanks: 1,
    entryIds: [124807],
    definitionIds: [{ id: 129645, specId: 269 }],
  },
  ASPECT_OF_HARMONY_TALENT: {
    id: 450508,
    name: 'Aspect of Harmony',
    icon: 'inv_ability_masterofharmonymonk_aspectofharmony',
    maxRanks: 1,
    entryIds: [125033],
    definitionIds: [{ id: 129869, specId: 270 }],
  },
  AUGUST_BLESSING_TALENT: {
    id: 454483,
    name: 'August Blessing',
    icon: 'inv_celestialserpentmount',
    maxRanks: 1,
    entryIds: [136147],
    definitionIds: [{ id: 140902, specId: 268 }],
  },
  AWAKENING_SPIRIT_TALENT: {
    id: 1262628,
    name: 'Awakening Spirit',
    icon: 'achievement_boss_golden_lotus_council',
    maxRanks: 1,
    entryIds: [125000],
    definitionIds: [{ id: 129838, specId: 268 }],
  },
  BALANCED_STRATAGEM_TALENT: {
    id: 450889,
    name: 'Balanced Stratagem',
    icon: 'ability_monk_sphereharmonydiscord',
    maxRanks: 1,
    entryIds: [125043],
    definitionIds: [{ id: 129879, specId: 270 }],
  },
  BLACKOUT_COMBO_TALENT: {
    id: 196736,
    name: 'Blackout Combo',
    icon: 'ability_monk_blackoutkick',
    maxRanks: 1,
    entryIds: [124996],
    definitionIds: [{ id: 129834, specId: 268 }],
  },
  BLACK_OX_BREW_TALENT: {
    id: 115399,
    name: 'Black Ox Brew',
    icon: 'ability_monk_chibrew',
    maxRanks: 1,
    entryIds: [124991],
    definitionIds: [{ id: 129829, specId: 268 }],
  },
  BOB_AND_WEAVE_TALENT: {
    id: 280515,
    name: 'Bob and Weave',
    icon: 'ability_creature_cursed_04',
    maxRanks: 1,
    entryIds: [124992],
    definitionIds: [{ id: 129830, specId: 268 }],
  },
  BOUNDING_AGILITY_TALENT: {
    id: 450520,
    name: 'Bounding Agility',
    icon: 'ability_monk_roll',
    maxRanks: 1,
    entryIds: [124955],
    definitionIds: [{ id: 129793, specId: 270 }],
  },
  BRAWLERS_INTENSITY_TALENT: {
    id: 451485,
    name: "Brawler's Intensity",
    icon: 'inv_staff_2h_artifactmonkeyking_d_03',
    maxRanks: 1,
    entryIds: [124809],
    definitionIds: [{ id: 129647, specId: 269 }],
  },
  BREATH_OF_FIRE_TALENT: {
    id: 115181,
    name: 'Breath of Fire',
    icon: 'ability_monk_breathoffire',
    maxRanks: 1,
    entryIds: [124843],
    definitionIds: [{ id: 129681, specId: 268 }],
  },
  BRING_ME_ANOTHER_1_BREWMASTER_TALENT: {
    id: 1265129,
    name: 'Bring Me Another',
    icon: 'inv12_apextalent_monk_bringmeanother',
    maxRanks: 1,
    entryIds: [137075],
    definitionIds: [{ id: 141839, specId: 268 }],
  },
  BRING_ME_ANOTHER_2_BREWMASTER_TALENT: {
    id: 1265138,
    name: 'Bring Me Another',
    icon: 'inv12_apextalent_monk_bringmeanother',
    maxRanks: 2,
    entryIds: [137074],
    definitionIds: [{ id: 141838, specId: 268 }],
  },
  BRING_ME_ANOTHER_3_BREWMASTER_TALENT: {
    id: 1265141,
    name: 'Bring Me Another',
    icon: 'inv12_apextalent_monk_bringmeanother',
    maxRanks: 1,
    entryIds: [137073],
    definitionIds: [{ id: 141837, specId: 268 }],
  },
  BURST_OF_LIFE_TALENT: {
    id: 399226,
    name: 'Burst of Life',
    icon: 'ability_rogue_imrovedrecuperate',
    maxRanks: 1,
    entryIds: [124877],
    definitionIds: [{ id: 129715, specId: 270 }],
  },
  CALMING_COALESCENCE_TALENT: {
    id: 388218,
    name: 'Calming Coalescence',
    icon: 'ability_monk_healthsphere',
    maxRanks: 1,
    entryIds: [124874],
    definitionIds: [{ id: 129712, specId: 270 }],
  },
  CALMING_PRESENCE_TALENT: {
    id: 388664,
    name: 'Calming Presence',
    icon: 'inv_misc_orb_01',
    maxRanks: 1,
    entryIds: [124944],
    definitionIds: [{ id: 129782, specId: 270 }],
  },
  CELERITY_TALENT: {
    id: 115173,
    name: 'Celerity',
    icon: 'ability_monk_quipunch',
    maxRanks: 1,
    entryIds: [124982],
    definitionIds: [{ id: 129820, specId: 270 }],
  },
  CELESTIAL_BREW_TALENT: {
    id: 322507,
    name: 'Celestial Brew',
    icon: 'ability_monk_ironskinbrew',
    maxRanks: 1,
    entryIds: [124841],
    definitionIds: [{ id: 129679, specId: 268 }],
  },
  CELESTIAL_CONDUIT_MISTWEAVER_TALENT: {
    id: 443028,
    name: 'Celestial Conduit',
    icon: 'inv_ability_conduitofthecelestialsmonk_celestialconduit',
    maxRanks: 1,
    entryIds: [136562],
    definitionIds: [{ id: 141335, specId: 270 }],
    manaCost: 12500,
  },
  CELESTIAL_CONDUIT_WINDWALKER_TALENT: {
    id: 1248989,
    name: 'Celestial Conduit',
    icon: 'inv_ability_conduitofthecelestialsmonk_celestialconduit',
    maxRanks: 1,
    entryIds: [136745],
    definitionIds: [{ id: 141517, specId: 269 }],
  },
  CELESTIAL_DETERMINATION_TALENT: {
    id: 450638,
    name: 'Celestial Determination',
    icon: 'ability_monk_essencefont',
    maxRanks: 1,
    entryIds: [124977],
    definitionIds: [{ id: 129815, specId: 270 }],
  },
  CELESTIAL_FLAMES_TALENT: {
    id: 1263353,
    name: 'Celestial Flames',
    icon: 'inv_misc_volatilefire',
    maxRanks: 1,
    entryIds: [124850],
    definitionIds: [{ id: 129688, specId: 268 }],
  },
  CELESTIAL_HARMONY_TALENT: {
    id: 343655,
    name: 'Celestial Harmony',
    icon: 'ability_monk_jadeserpentbreath',
    maxRanks: 1,
    entryIds: [124913],
    definitionIds: [{ id: 129751, specId: 270 }],
  },
  CELESTIAL_INFUSION_TALENT: {
    id: 1241059,
    name: 'Celestial Infusion',
    icon: 'ability_monk_tigereyebrandy',
    maxRanks: 1,
    entryIds: [136146],
    definitionIds: [{ id: 140901, specId: 268 }],
  },
  CHARRED_PASSIONS_TALENT: {
    id: 386965,
    name: 'Charred Passions',
    icon: 'ability_monk_mightyoxkick',
    maxRanks: 1,
    entryIds: [124986],
    definitionIds: [{ id: 129824, specId: 268 }],
  },
  CHI_BURST_TALENT: {
    id: 123986,
    name: 'Chi Burst',
    icon: 'spell_arcane_arcanetorrent',
    maxRanks: 1,
    entryIds: [126501],
    definitionIds: [{ id: 131327, specId: 268 }],
  },
  CHI_JIS_SWIFTNESS_TALENT: {
    id: 443566,
    name: "Chi-Ji's Swiftness",
    icon: 'inv_shoulder_leather_raidmonkemerald_d_01',
    maxRanks: 1,
    entryIds: [125055],
    definitionIds: [{ id: 129887, specId: 270 }],
  },
  CHI_PROFICIENCY_TALENT: {
    id: 450426,
    name: 'Chi Proficiency',
    icon: 'ability_monk_chiswirl',
    maxRanks: 2,
    entryIds: [124964],
    definitionIds: [{ id: 129802, specId: 270 }],
  },
  CHI_TORPEDO_TALENT: {
    id: 115008,
    name: 'Chi Torpedo',
    icon: 'ability_monk_quitornado',
    maxRanks: 1,
    entryIds: [124981],
    definitionIds: [{ id: 129819, specId: 270 }],
  },
  CHI_TRANSFER_TALENT: {
    id: 1272452,
    name: 'Chi Transfer',
    icon: 'ability_monk_zenmeditation',
    maxRanks: 1,
    entryIds: [124974],
    definitionIds: [{ id: 129812, specId: 270 }],
  },
  CHI_WARDING_TALENT: {
    id: 1277444,
    name: 'Chi Warding',
    icon: 'inv_belt__inv_leather_raidmonkmythic_s_01',
    maxRanks: 1,
    entryIds: [136598],
    definitionIds: [{ id: 141371, specId: 270 }],
  },
  CHI_WAVE_TALENT: {
    id: 450391,
    name: 'Chi Wave',
    icon: 'ability_monk_chiwave',
    maxRanks: 1,
    entryIds: [126502, 126500],
    definitionIds: [
      { id: 131328, specId: 268 },
      { id: 131326, specId: 270 },
    ],
  },
  CHRYSALIS_TALENT: {
    id: 202424,
    name: 'Chrysalis',
    icon: 'ability_monk_domeofmist',
    maxRanks: 1,
    entryIds: [124878],
    definitionIds: [{ id: 129716, specId: 270 }],
  },
  CLARITY_OF_PURPOSE_TALENT: {
    id: 451017,
    name: 'Clarity of Purpose',
    icon: 'ability_titankeeper_cleanse',
    maxRanks: 1,
    entryIds: [125040],
    definitionIds: [{ id: 129876, specId: 270 }],
  },
  COALESCENCE_TALENT: {
    id: 450529,
    name: 'Coalescence',
    icon: 'ability_monk_effuse',
    maxRanks: 1,
    entryIds: [125039],
    definitionIds: [{ id: 129875, specId: 270 }],
  },
  COMBAT_STANCE_TALENT: {
    id: 1272844,
    name: 'Combat Stance',
    icon: 'ability_monk_roll',
    maxRanks: 1,
    entryIds: [125076],
    definitionIds: [{ id: 129908, specId: 269 }],
  },
  COMBAT_WISDOM_TALENT: {
    id: 121817,
    name: 'Combat Wisdom',
    icon: 'ability_monk_expelharm',
    maxRanks: 1,
    entryIds: [125025],
    definitionIds: [{ id: 129863, specId: 269 }],
  },
  COMBO_BREAKER_TALENT: {
    id: 137384,
    name: 'Combo Breaker',
    icon: 'pandarenracial_bouncy',
    maxRanks: 1,
    entryIds: [125022],
    definitionIds: [{ id: 129860, specId: 269 }],
  },
  COMMUNION_WITH_WIND_TALENT: {
    id: 451576,
    name: 'Communion With Wind',
    icon: 'ability_skyreach_four_wind',
    maxRanks: 1,
    entryIds: [124812],
    definitionIds: [{ id: 129650, specId: 269 }],
  },
  COUNTERSTRIKE_TALENT: {
    id: 383785,
    name: 'Counterstrike',
    icon: 'ability_monk_palmstrike',
    maxRanks: 1,
    entryIds: [124854],
    definitionIds: [{ id: 129692, specId: 268 }],
  },
  COURAGE_OF_THE_WHITE_TIGER_TALENT: {
    id: 443087,
    name: 'Courage of the White Tiger',
    icon: 'ability_monk_summontigerstatue',
    maxRanks: 1,
    entryIds: [125061],
    definitionIds: [{ id: 129893, specId: 270 }],
  },
  CRANE_STYLE_TALENT: {
    id: 446260,
    name: 'Crane Style',
    icon: 'ability_monk_mightyoxkick',
    maxRanks: 1,
    entryIds: [124876],
    definitionIds: [{ id: 129714, specId: 270 }],
  },
  CRANE_VORTEX_TALENT: {
    id: 388848,
    name: 'Crane Vortex',
    icon: 'ability_monk_cranekick_new',
    maxRanks: 1,
    entryIds: [125018],
    definitionIds: [{ id: 129856, specId: 269 }],
  },
  CRASHING_FISTS_TALENT: {
    id: 1248747,
    name: 'Crashing Fists',
    icon: 'inv_fistofthewhitetiger',
    maxRanks: 1,
    entryIds: [134453],
    definitionIds: [{ id: 139224, specId: 269 }],
  },
  CRASHING_MOMENTUM_TALENT: {
    id: 450335,
    name: 'Crashing Momentum',
    icon: 'ability_monk_blackoutkick',
    maxRanks: 1,
    entryIds: [124940],
    definitionIds: [{ id: 129778, specId: 270 }],
  },
  CYCLONES_DRIFT_TALENT: {
    id: 1248749,
    name: "Cyclone's Drift",
    icon: 'ability_skyreach_wind',
    maxRanks: 1,
    entryIds: [124830],
    definitionIds: [{ id: 129668, specId: 269 }],
  },
  DANCE_OF_CHI_JI_MISTWEAVER_TALENT: {
    id: 438439,
    name: 'Dance of Chi-Ji',
    icon: 'ability_monk_cranekick_new',
    maxRanks: 1,
    entryIds: [124887],
    definitionIds: [{ id: 129725, specId: 270 }],
  },
  DANCE_OF_CHI_JI_WINDWALKER_TALENT: {
    id: 325201,
    name: 'Dance of Chi-Ji',
    icon: 'ability_monk_cranekick_new',
    maxRanks: 1,
    entryIds: [124834],
    definitionIds: [{ id: 129672, specId: 269 }],
  },
  DANCE_OF_THE_WIND_BREWMASTER_TALENT: {
    id: 414132,
    name: 'Dance of the Wind',
    icon: 'ability_monk_dematerialize',
    maxRanks: 1,
    entryIds: [124979],
    definitionIds: [{ id: 129817, specId: 268 }],
  },
  DANCE_OF_THE_WIND_SHARED_TALENT: {
    id: 432181,
    name: 'Dance of the Wind',
    icon: 'ability_monk_dematerialize',
    maxRanks: 1,
    entryIds: [124927, 124929],
    definitionIds: [
      { id: 129765, specId: 269 },
      { id: 129767, specId: 270 },
    ],
  },
  DANCING_MISTS_TALENT: {
    id: 388701,
    name: 'Dancing Mists',
    icon: 'ability_monk_serenity',
    maxRanks: 1,
    entryIds: [124893],
    definitionIds: [{ id: 129731, specId: 270 }],
  },
  DEEP_CLARITY_TALENT: {
    id: 446345,
    name: 'Deep Clarity',
    icon: 'ability_monk_zenmeditation',
    maxRanks: 1,
    entryIds: [124906],
    definitionIds: [{ id: 129744, specId: 270 }],
  },
  DETOX_TALENT: {
    id: 218164,
    name: 'Detox',
    icon: 'ability_rogue_imrovedrecuperate',
    maxRanks: 1,
    entryIds: [124867, 124941],
    definitionIds: [
      { id: 129705, specId: 268 },
      { id: 129779, specId: 269 },
    ],
    energyCost: 10,
  },
  DIFFUSE_MAGIC_TALENT: {
    id: 1243287,
    name: 'Diffuse Magic',
    icon: 'spell_monk_diffusemagic',
    maxRanks: 1,
    entryIds: [134029],
    definitionIds: [{ id: 138812, specId: 270 }],
  },
  DISABLE_TALENT: {
    id: 116095,
    name: 'Disable',
    icon: 'ability_shockwave',
    maxRanks: 1,
    entryIds: [124939],
    definitionIds: [{ id: 129777, specId: 270 }],
    energyCost: 15,
  },
  DRAGONFIRE_BREW_TALENT: {
    id: 383994,
    name: 'Dragonfire Brew',
    icon: 'spell_fire_burnout',
    maxRanks: 1,
    entryIds: [124987],
    definitionIds: [{ id: 129825, specId: 268 }],
  },
  DRINKING_HORN_COVER_TALENT: {
    id: 391370,
    name: 'Drinking Horn Cover',
    icon: 'ability_warrior_unrelentingassault',
    maxRanks: 1,
    entryIds: [124825],
    definitionIds: [{ id: 129663, specId: 269 }],
  },
  DUAL_THREAT_TALENT: {
    id: 451823,
    name: 'Dual Threat',
    icon: 'ability_monk_standingkick',
    maxRanks: 1,
    entryIds: [124828],
    definitionIds: [{ id: 129666, specId: 269 }],
  },
  ECHO_TECHNIQUE_TALENT: {
    id: 1250042,
    name: 'Echo Technique',
    icon: 'ability_monk_cranekick',
    maxRanks: 1,
    entryIds: [125009],
    definitionIds: [{ id: 129847, specId: 269 }],
  },
  EFFICIENT_TRAINING_TALENT: {
    id: 450989,
    name: 'Efficient Training',
    icon: 'inv_fistofthewhitetiger',
    maxRanks: 1,
    entryIds: [125072],
    definitionIds: [{ id: 129904, specId: 269 }],
  },
  ELIXIR_OF_DETERMINATION_TALENT: {
    id: 455139,
    name: 'Elixir of Determination',
    icon: 'monk_ability_cherrymanatea',
    maxRanks: 1,
    entryIds: [124862],
    definitionIds: [{ id: 129700, specId: 268 }],
  },
  ELUSIVE_FOOTWORK_TALENT: {
    id: 387046,
    name: 'Elusive Footwork',
    icon: 'ability_monk_shuffle',
    maxRanks: 1,
    entryIds: [136145],
    definitionIds: [{ id: 140900, specId: 268 }],
  },
  ELUSIVE_MISTS_TALENT: {
    id: 388681,
    name: 'Elusive Mists',
    icon: 'ability_monk_soothingmists',
    maxRanks: 1,
    entryIds: [124934],
    definitionIds: [{ id: 129772, specId: 270 }],
  },
  EMPERORS_ELIXIR_TALENT: {
    id: 1268807,
    name: "Emperor's Elixir",
    icon: 'inv_drink_25_honeytea',
    maxRanks: 1,
    entryIds: [124881],
    definitionIds: [{ id: 129719, specId: 270 }],
  },
  EMPERORS_FAVOR_TALENT: {
    id: 471761,
    name: "Emperor's Favor",
    icon: 'inv_leather_raidmonkt2_d_01_helm',
    maxRanks: 1,
    entryIds: [128344],
    definitionIds: [{ id: 133150, specId: 270 }],
  },
  EMPTY_THE_CELLAR_TALENT: {
    id: 1262329,
    name: 'Empty the Cellar',
    icon: 'ability_vehicle_liquidpyrite',
    maxRanks: 1,
    entryIds: [125002],
    definitionIds: [{ id: 129840, specId: 268 }],
  },
  ENDLESS_DRAUGHT_TALENT: {
    id: 450892,
    name: 'Endless Draught',
    icon: 'inv_drink_25_honeytea',
    maxRanks: 1,
    entryIds: [125036],
    definitionIds: [{ id: 129872, specId: 270 }],
  },
  ENERGIZING_BREW_TALENT: {
    id: 422031,
    name: 'Energizing Brew',
    icon: 'ui_profession_herbalism',
    maxRanks: 1,
    entryIds: [124917],
    definitionIds: [{ id: 129755, specId: 270 }],
  },
  ENERGY_BURST_TALENT: {
    id: 451498,
    name: 'Energy Burst',
    icon: 'ability_monk_blackoutstrike',
    maxRanks: 1,
    entryIds: [124829],
    definitionIds: [{ id: 129667, specId: 269 }],
  },
  ENERGY_TRANSFER_TALENT: {
    id: 450631,
    name: 'Energy Transfer',
    icon: 'monk_ability_avertharm',
    maxRanks: 1,
    entryIds: [124942, 136596],
    definitionIds: [
      { id: 129780, specId: 268 },
      { id: 141369, specId: 269 },
    ],
  },
  ENVELOPING_MIST_TALENT: {
    id: 124682,
    name: 'Enveloping Mist',
    icon: 'spell_monk_envelopingmist',
    maxRanks: 1,
    entryIds: [124922],
    definitionIds: [{ id: 129760, specId: 270 }],
    manaCost: 9000,
  },
  ESCAPE_FROM_REALITY_TALENT: {
    id: 394110,
    name: 'Escape from Reality',
    icon: 'monk_ability_transcendence',
    maxRanks: 1,
    entryIds: [124973],
    definitionIds: [{ id: 129811, specId: 270 }],
  },
  EXPEDITIOUS_FORTIFICATION_TALENT: {
    id: 388813,
    name: 'Expeditious Fortification',
    icon: 'ability_monk_fortifyingale_new',
    maxRanks: 1,
    entryIds: [124969],
    definitionIds: [{ id: 129807, specId: 270 }],
  },
  EXPLODING_KEG_TALENT: {
    id: 325153,
    name: 'Exploding Keg',
    icon: 'inv12_ability_monk_explodingkeg',
    maxRanks: 1,
    entryIds: [125001],
    definitionIds: [{ id: 129839, specId: 268 }],
  },
  FACE_PALM_TALENT: {
    id: 389942,
    name: 'Face Palm',
    icon: 'ability_monk_tigerpalm',
    maxRanks: 1,
    entryIds: [124855],
    definitionIds: [{ id: 129693, specId: 268 }],
  },
  FAST_FEET_BREWMASTER_TALENT: {
    id: 1261543,
    name: 'Fast Feet',
    icon: 'ability_monk_mightyoxkick',
    maxRanks: 1,
    entryIds: [136085],
    definitionIds: [{ id: 140840, specId: 268 }],
  },
  FAST_FEET_SHARED_TALENT: {
    id: 388809,
    name: 'Fast Feet',
    icon: 'ability_monk_risingsunkick',
    maxRanks: 1,
    entryIds: [124984],
    definitionIds: [{ id: 129822, specId: 270 }],
  },
  FATAL_TOUCH_TALENT: {
    id: 394123,
    name: 'Fatal Touch',
    icon: 'ability_monk_touchofdeath',
    maxRanks: 1,
    entryIds: [124975],
    definitionIds: [{ id: 129813, specId: 270 }],
  },
  FEROCIOUSNESS_TALENT: {
    id: 458623,
    name: 'Ferociousness',
    icon: 'ability_mount_whitetiger',
    maxRanks: 2,
    entryIds: [124805],
    definitionIds: [{ id: 129643, specId: 269 }],
  },
  FEROCITY_OF_XUEN_TALENT: {
    id: 388674,
    name: 'Ferocity of Xuen',
    icon: 'ability_mount_pinktiger',
    maxRanks: 2,
    entryIds: [124961],
    definitionIds: [{ id: 129799, specId: 270 }],
  },
  FISTS_OF_FURY_TALENT: {
    id: 113656,
    name: 'Fists of Fury',
    icon: 'monk_ability_fistoffury',
    maxRanks: 1,
    entryIds: [125026],
    definitionIds: [{ id: 129864, specId: 269 }],
    chiCost: 3,
  },
  FLOWING_WISDOM_TALENT: {
    id: 1262672,
    name: 'Flowing Wisdom',
    icon: 'ability_monk_flyingdragonkick',
    maxRanks: 1,
    entryIds: [135958],
    definitionIds: [{ id: 140713, specId: 270 }],
  },
  FLOW_OF_CHI_TALENT: {
    id: 450569,
    name: 'Flow of Chi',
    icon: 'ability_monk_healthsphere',
    maxRanks: 1,
    entryIds: [124965],
    definitionIds: [{ id: 129803, specId: 270 }],
  },
  FLUIDITY_OF_MOTION_TALENT: {
    id: 387230,
    name: 'Fluidity of Motion',
    icon: 'ability_monk_standingkick',
    maxRanks: 1,
    entryIds: [124852],
    definitionIds: [{ id: 129690, specId: 268 }],
  },
  FLURRY_OF_XUEN_TALENT: {
    id: 452137,
    name: 'Flurry of Xuen',
    icon: 'monk_stance_whitetiger',
    maxRanks: 1,
    entryIds: [125011],
    definitionIds: [{ id: 129849, specId: 269 }],
  },
  FLURRY_STRIKES_TALENT: {
    id: 450615,
    name: 'Flurry Strikes',
    icon: 'inv_ability_shadopanmonk_flurrystrikes',
    maxRanks: 1,
    entryIds: [125069],
    definitionIds: [{ id: 129901, specId: 269 }],
  },
  FOCUSED_THUNDER_TALENT: {
    id: 197895,
    name: 'Focused Thunder',
    icon: 'spell_monk_nimblebrew',
    maxRanks: 1,
    entryIds: [124897],
    definitionIds: [{ id: 129735, specId: 270 }],
  },
  FORTIFYING_BREW_DETERMINATION_TALENT: {
    id: 322960,
    name: 'Fortifying Brew: Determination',
    icon: 'ability_monk_fortifyingale_new',
    maxRanks: 1,
    entryIds: [124842],
    definitionIds: [{ id: 129680, specId: 268 }],
  },
  FORTIFYING_BREW_TALENT: {
    id: 388917,
    name: 'Fortifying Brew',
    icon: 'ability_monk_fortifyingale_new',
    maxRanks: 1,
    entryIds: [124968],
    definitionIds: [{ id: 129806, specId: 270 }],
  },
  FUEL_ON_THE_FIRE_TALENT: {
    id: 1262017,
    name: 'Fuel on the Fire',
    icon: 'spell_shaman_stormearthfire',
    maxRanks: 1,
    entryIds: [125003],
    definitionIds: [{ id: 129841, specId: 268 }],
  },
  GAI_PLINS_IMPERIAL_BREW_TALENT: {
    id: 383700,
    name: "Gai Plin's Imperial Brew",
    icon: 'inv_misc_beer_06',
    maxRanks: 1,
    entryIds: [124859],
    definitionIds: [{ id: 129697, specId: 268 }],
  },
  GIFT_OF_THE_CELESTIALS_TALENT: {
    id: 388212,
    name: 'Gift of the Celestials',
    icon: 'inv_pet_jadeserpentpet',
    maxRanks: 1,
    entryIds: [124894],
    definitionIds: [{ id: 129732, specId: 270 }],
  },
  GIFT_OF_THE_OX_TALENT: {
    id: 124502,
    name: 'Gift of the Ox',
    icon: 'ability_druid_giftoftheearthmother',
    maxRanks: 1,
    entryIds: [124845],
    definitionIds: [{ id: 129683, specId: 268 }],
  },
  GLORY_OF_THE_DAWN_TALENT: {
    id: 392958,
    name: 'Glory of the Dawn',
    icon: 'ability_monk_mightyoxkick',
    maxRanks: 1,
    entryIds: [124810],
    definitionIds: [{ id: 129648, specId: 269 }],
  },
  GRACE_OF_THE_CRANE_TALENT: {
    id: 388811,
    name: 'Grace of the Crane',
    icon: 'monk_ability_cherrymanatea',
    maxRanks: 1,
    entryIds: [124936],
    definitionIds: [{ id: 129774, specId: 270 }],
  },
  HARDENED_SOLES_TALENT: {
    id: 391383,
    name: 'Hardened Soles',
    icon: 'ability_monk_roundhousekick',
    maxRanks: 2,
    entryIds: [124819],
    definitionIds: [{ id: 129657, specId: 269 }],
  },
  HARMONIC_COMBO_TALENT: {
    id: 1250041,
    name: 'Harmonic Combo',
    icon: 'ability_monk_serenity',
    maxRanks: 1,
    entryIds: [128712],
    definitionIds: [{ id: 133514, specId: 269 }],
  },
  HARMONIC_GAMBIT_TALENT: {
    id: 450870,
    name: 'Harmonic Gambit',
    icon: 'passive_monk_teachingsofmonastery',
    maxRanks: 1,
    entryIds: [125034],
    definitionIds: [{ id: 129870, specId: 270 }],
  },
  HARMONIC_SURGE_TALENT: {
    id: 1270958,
    name: 'Harmonic Surge',
    icon: 'ability_socererking_forcenova',
    maxRanks: 1,
    entryIds: [135952],
    definitionIds: [{ id: 140707, specId: 270 }],
  },
  HASTY_PROVOCATION_TALENT: {
    id: 328670,
    name: 'Hasty Provocation',
    icon: 'ability_monk_provoke',
    maxRanks: 1,
    entryIds: [124950],
    definitionIds: [{ id: 129788, specId: 270 }],
  },
  HEALING_ELIXIR_TALENT: {
    id: 122280,
    name: 'Healing Elixir',
    icon: 'ability_monk_jasmineforcetea',
    maxRanks: 1,
    entryIds: [124890],
    definitionIds: [{ id: 129728, specId: 270 }],
  },
  HEALING_WINDS_TALENT: {
    id: 450560,
    name: 'Healing Winds',
    icon: 'ability_monk_pathofmists',
    maxRanks: 1,
    entryIds: [124966],
    definitionIds: [{ id: 129804, specId: 270 }],
  },
  HEART_OF_THE_JADE_SERPENT_TALENT: {
    id: 443294,
    name: 'Heart of the Jade Serpent',
    icon: 'ability_monk_dragonkick',
    maxRanks: 1,
    entryIds: [135959],
    definitionIds: [{ id: 140714, specId: 270 }],
  },
  HEART_OF_THE_OX_TALENT: {
    id: 1263245,
    name: 'Heart of the Ox',
    icon: 'inv_muskox_white',
    maxRanks: 1,
    entryIds: [136177],
    definitionIds: [{ id: 140950, specId: 268 }],
  },
  HIGH_IMPACT_TALENT: {
    id: 450982,
    name: 'High Impact',
    icon: 'ability_monk_powerstrikes',
    maxRanks: 1,
    entryIds: [125067],
    definitionIds: [{ id: 129899, specId: 269 }],
  },
  HIGH_TOLERANCE_TALENT: {
    id: 196737,
    name: 'High Tolerance',
    icon: 'monk_ability_avertharm',
    maxRanks: 2,
    entryIds: [124990],
    definitionIds: [{ id: 129828, specId: 268 }],
  },
  HIT_COMBO_TALENT: {
    id: 196740,
    name: 'Hit Combo',
    icon: 'ability_monk_palmstrike',
    maxRanks: 1,
    entryIds: [125023],
    definitionIds: [{ id: 129861, specId: 269 }],
  },
  HURRICANES_VAULT_TALENT: {
    id: 1248837,
    name: "Hurricane's Vault",
    icon: 'ability_druid_galewinds',
    maxRanks: 1,
    entryIds: [124814],
    definitionIds: [{ id: 129652, specId: 269 }],
  },
  IMPROVED_BLACKOUT_KICK_TALENT: {
    id: 383695,
    name: 'Improved Blackout Kick',
    icon: 'ability_monk_roundhousekick',
    maxRanks: 1,
    entryIds: [124846],
    definitionIds: [{ id: 129684, specId: 268 }],
  },
  IMPROVED_DETOX_TALENT: {
    id: 388874,
    name: 'Improved Detox',
    icon: 'ability_rogue_imrovedrecuperate',
    maxRanks: 1,
    entryIds: [124866],
    definitionIds: [{ id: 129704, specId: 270 }],
  },
  IMPROVED_TOUCH_OF_DEATH_TALENT: {
    id: 322113,
    name: 'Improved Touch of Death',
    icon: 'ability_monk_touchofdeath',
    maxRanks: 1,
    entryIds: [124930],
    definitionIds: [{ id: 129768, specId: 270 }],
  },
  INITIATORS_EDGE_TALENT: {
    id: 1272849,
    name: "Initiator's Edge",
    icon: 'crest_monk',
    maxRanks: 1,
    entryIds: [125075],
    definitionIds: [{ id: 129907, specId: 269 }],
  },
  INNER_COMPASS_TALENT: {
    id: 443571,
    name: 'Inner Compass',
    icon: 'inv_10_dungeonjewelry_explorer_trinket_1compass_color2',
    maxRanks: 1,
    entryIds: [125052],
    definitionIds: [{ id: 129884, specId: 270 }],
  },
  INNER_PEACE_TALENT: {
    id: 397768,
    name: 'Inner Peace',
    icon: 'ability_monk_jasmineforcetea',
    maxRanks: 1,
    entryIds: [125021],
    definitionIds: [{ id: 129859, specId: 269 }],
  },
  INVIGORATING_MISTS_TALENT: {
    id: 274586,
    name: 'Invigorating Mists',
    icon: 'ability_monk_vivify',
    maxRanks: 1,
    entryIds: [124891],
    definitionIds: [{ id: 129729, specId: 270 }],
  },
  INVOKE_CHI_JI_THE_RED_CRANE_TALENT: {
    id: 325197,
    name: 'Invoke Chi-Ji, the Red Crane',
    icon: 'inv_pet_cranegod',
    maxRanks: 1,
    entryIds: [124914],
    definitionIds: [{ id: 129752, specId: 270 }],
    manaCost: 12500,
  },
  INVOKE_NIUZAO_THE_BLACK_OX_TALENT: {
    id: 132578,
    name: 'Invoke Niuzao, the Black Ox',
    icon: 'spell_monk_brewmaster_spec',
    maxRanks: 1,
    entryIds: [124849],
    definitionIds: [{ id: 129687, specId: 268 }],
  },
  INVOKE_XUEN_THE_WHITE_TIGER_TALENT: {
    id: 123904,
    name: 'Invoke Xuen, the White Tiger',
    icon: 'ability_monk_summontigerstatue',
    maxRanks: 1,
    entryIds: [125062],
    definitionIds: [{ id: 129894, specId: 269 }],
  },
  INVOKE_YULON_THE_JADE_SERPENT_TALENT: {
    id: 322118,
    name: "Invoke Yu'lon, the Jade Serpent",
    icon: 'ability_monk_dragonkick',
    maxRanks: 1,
    entryIds: [124915],
    definitionIds: [{ id: 129753, specId: 270 }],
    manaCost: 12500,
  },
  IRONSHELL_BREW_TALENT: {
    id: 388814,
    name: 'Ironshell Brew',
    icon: 'ability_monk_fortifyingale_new',
    maxRanks: 1,
    entryIds: [124970],
    definitionIds: [{ id: 129808, specId: 270 }],
  },
  JADEFIRE_STOMP_TALENT: {
    id: 457974,
    name: 'Jadefire Stomp',
    icon: 'inv_ability_monk_jadefirestomp',
    maxRanks: 1,
    entryIds: [124817],
    definitionIds: [{ id: 129655, specId: 269 }],
  },
  JADEFIRE_TEACHINGS_TALENT: {
    id: 467293,
    name: 'Jadefire Teachings',
    icon: 'inv_misc_book_07',
    maxRanks: 1,
    entryIds: [124882],
    definitionIds: [{ id: 129720, specId: 270 }],
  },
  JADE_BOND_TALENT: {
    id: 388031,
    name: 'Jade Bond',
    icon: 'inv_inscription_deck_jadeserpent',
    maxRanks: 1,
    entryIds: [124895],
    definitionIds: [{ id: 129733, specId: 270 }],
  },
  JADE_EMPOWERMENT_TALENT: {
    id: 467316,
    name: 'Jade Empowerment',
    icon: 'ability_monk_cracklingjadelightning',
    maxRanks: 1,
    entryIds: [124910],
    definitionIds: [{ id: 129748, specId: 270 }],
  },
  JADE_FLASH_TALENT: {
    id: 1262334,
    name: 'Jade Flash',
    icon: 'shaman_pvp_staticcling',
    maxRanks: 1,
    entryIds: [124844],
    definitionIds: [{ id: 129682, specId: 268 }],
  },
  JADE_IGNITION_TALENT: {
    id: 392979,
    name: 'Jade Ignition',
    icon: 'ability_monk_chiexplosion',
    maxRanks: 1,
    entryIds: [124822],
    definitionIds: [{ id: 129660, specId: 269 }],
  },
  JADE_INFUSION_TALENT: {
    id: 1242910,
    name: 'Jade Infusion',
    icon: 'ability_monk_summonserpentstatue',
    maxRanks: 1,
    entryIds: [124958],
    definitionIds: [{ id: 129796, specId: 270 }],
  },
  JADE_SANCTUARY_TALENT: {
    id: 443059,
    name: 'Jade Sanctuary',
    icon: 'ability_monk_jadeserpentbreath',
    maxRanks: 1,
    entryIds: [125056],
    definitionIds: [{ id: 129888, specId: 270 }],
  },
  JADE_WALK_TALENT: {
    id: 450553,
    name: 'Jade Walk',
    icon: 'spell_lifegivingspeed',
    maxRanks: 1,
    entryIds: [124954],
    definitionIds: [{ id: 129792, specId: 270 }],
  },
  KEG_SMASH_TALENT: {
    id: 121253,
    name: 'Keg Smash',
    icon: 'achievement_brewery_2',
    maxRanks: 1,
    entryIds: [124865],
    definitionIds: [{ id: 129703, specId: 268 }],
    energyCost: 40,
  },
  KNOWLEDGE_OF_THE_BROKEN_TEMPLE_TALENT: {
    id: 451529,
    name: 'Knowledge of the Broken Temple',
    icon: 'inv_glove_leather_pvpmonk_f_01',
    maxRanks: 1,
    entryIds: [125019],
    definitionIds: [{ id: 129857, specId: 269 }],
  },
  LEGACY_OF_WISDOM_TALENT: {
    id: 404408,
    name: 'Legacy of Wisdom',
    icon: 'misc_legionfall_monk',
    maxRanks: 1,
    entryIds: [124901],
    definitionIds: [{ id: 129739, specId: 270 }],
  },
  LIFECYCLES_TALENT: {
    id: 197915,
    name: 'Lifecycles',
    icon: 'ability_monk_souldance',
    maxRanks: 1,
    entryIds: [124916],
    definitionIds: [{ id: 129754, specId: 270 }],
  },
  LIFE_COCOON_TALENT: {
    id: 116849,
    name: 'Life Cocoon',
    icon: 'ability_monk_chicocoon',
    maxRanks: 1,
    entryIds: [124875],
    definitionIds: [{ id: 129713, specId: 270 }],
    manaCost: 6000,
  },
  LIGHTER_THAN_AIR_TALENT: {
    id: 449582,
    name: 'Lighter Than Air',
    icon: 'ability_monk_ridethewind',
    maxRanks: 1,
    entryIds: [124963],
    definitionIds: [{ id: 129801, specId: 270 }],
  },
  LIGHT_BREWING_TALENT: {
    id: 325093,
    name: 'Light Brewing',
    icon: 'spell_brew_wheat',
    maxRanks: 1,
    entryIds: [124858],
    definitionIds: [{ id: 129696, specId: 268 }],
  },
  LOTUS_INFUSION_TALENT: {
    id: 458431,
    name: 'Lotus Infusion',
    icon: 'inv_misc_herb_chamlotus',
    maxRanks: 1,
    entryIds: [124905],
    definitionIds: [{ id: 129743, specId: 270 }],
  },
  MANA_TEA_TALENT: {
    id: 115869,
    name: 'Mana Tea',
    icon: 'monk_ability_cherrymanatea',
    maxRanks: 1,
    entryIds: [124920],
    definitionIds: [{ id: 129758, specId: 270 }],
    manaCost: 2500,
  },
  MANIFESTATION_TALENT: {
    id: 450875,
    name: 'Manifestation',
    icon: 'inv_shoulder_inv_leather_raidmonk_s_01',
    maxRanks: 1,
    entryIds: [125032],
    definitionIds: [{ id: 129868, specId: 270 }],
  },
  MANTRA_OF_PURITY_TALENT: {
    id: 451036,
    name: 'Mantra of Purity',
    icon: 'ability_monk_domeofmist',
    maxRanks: 1,
    entryIds: [125042],
    definitionIds: [{ id: 129878, specId: 270 }],
  },
  MANTRA_OF_TENACITY_TALENT: {
    id: 451029,
    name: 'Mantra of Tenacity',
    icon: 'spell_monk_brewmastertraining',
    maxRanks: 1,
    entryIds: [125041],
    definitionIds: [{ id: 129877, specId: 270 }],
  },
  MARTIAL_AGILITY_TALENT: {
    id: 1272685,
    name: 'Martial Agility',
    icon: 'ability_monk_dpsstance',
    maxRanks: 1,
    entryIds: [125015],
    definitionIds: [{ id: 129853, specId: 269 }],
  },
  MARTIAL_INSTINCTS_TALENT: {
    id: 450427,
    name: 'Martial Instincts',
    icon: 'ability_monk_palmstrike',
    maxRanks: 2,
    entryIds: [124976],
    definitionIds: [{ id: 129814, specId: 270 }],
  },
  MARTIAL_PRECISION_TALENT: {
    id: 450990,
    name: 'Martial Precision',
    icon: 'ability_monk_jab',
    maxRanks: 1,
    entryIds: [125066],
    definitionIds: [{ id: 129898, specId: 269 }],
  },
  MEDITATIVE_FOCUS_TALENT: {
    id: 1271105,
    name: 'Meditative Focus',
    icon: 'inv_misc_herb_mountainsilversage',
    maxRanks: 1,
    entryIds: [135954],
    definitionIds: [{ id: 140709, specId: 270 }],
  },
  MEMORY_OF_THE_MONASTERY_TALENT: {
    id: 454969,
    name: 'Memory of the Monastery',
    icon: 'ability_mount_goatmountwhite',
    maxRanks: 1,
    entryIds: [125016],
    definitionIds: [{ id: 129854, specId: 269 }],
  },
  MERIDIAN_STRIKES_TALENT: {
    id: 391330,
    name: 'Meridian Strikes',
    icon: 'ability_monk_touchofdeath',
    maxRanks: 1,
    entryIds: [124835],
    definitionIds: [{ id: 129673, specId: 269 }],
  },
  MIGHTY_STOMP_TALENT: {
    id: 322740,
    name: 'Mighty Stomp',
    icon: 'inv_inscription_trinket_ox',
    maxRanks: 1,
    entryIds: [124847],
    definitionIds: [{ id: 129685, specId: 268 }],
  },
  MISTLINE_TALENT: {
    id: 1280297,
    name: 'Mistline',
    icon: 'ability_monk_surgingmist',
    maxRanks: 1,
    entryIds: [124907],
    definitionIds: [{ id: 129745, specId: 270 }],
  },
  MISTS_OF_LIFE_TALENT: {
    id: 388548,
    name: 'Mists of Life',
    icon: 'inv_shoulder__inv_leather_raidmonkmythic_s_01',
    maxRanks: 1,
    entryIds: [124879],
    definitionIds: [{ id: 129717, specId: 270 }],
  },
  MISTY_COALESCENCE_TALENT: {
    id: 1268817,
    name: 'Misty Coalescence',
    icon: 'inv_ability_monk_renewingmists_active',
    maxRanks: 1,
    entryIds: [124888],
    definitionIds: [{ id: 129726, specId: 270 }],
  },
  MISTY_PEAKS_TALENT: {
    id: 388682,
    name: 'Misty Peaks',
    icon: 'achievement_zone_stormpeaks_10',
    maxRanks: 2,
    entryIds: [124896],
    definitionIds: [{ id: 129734, specId: 270 }],
  },
  MIST_CALLER_TALENT: {
    id: 1266811,
    name: 'Mist Caller',
    icon: 'ability_monk_serenity',
    maxRanks: 1,
    entryIds: [136510],
    definitionIds: [{ id: 141283, specId: 270 }],
  },
  MIST_WRAP_TALENT: {
    id: 197900,
    name: 'Mist Wrap',
    icon: 'ability_monk_pathofmists',
    maxRanks: 1,
    entryIds: [124871],
    definitionIds: [{ id: 129709, specId: 270 }],
  },
  MOMENTUM_BOOST_TALENT: {
    id: 451294,
    name: 'Momentum Boost',
    icon: 'inv_belt_leather_raidmonk_n_01',
    maxRanks: 1,
    entryIds: [124820],
    definitionIds: [{ id: 129658, specId: 269 }],
  },
  MORNING_BREEZE_TALENT: {
    id: 1277302,
    name: 'Morning Breeze',
    icon: 'expansionicon_mistsofpandaria',
    maxRanks: 1,
    entryIds: [124909],
    definitionIds: [{ id: 129747, specId: 270 }],
  },
  NIUZAOS_PROTECTION_TALENT: {
    id: 442747,
    name: "Niuzao's Protection",
    icon: 'ability_monk_chargingoxwave',
    maxRanks: 1,
    entryIds: [125057],
    definitionIds: [{ id: 129889, specId: 270 }],
  },
  NIUZAOS_RESOLVE_TALENT: {
    id: 1241097,
    name: "Niuzao's Resolve",
    icon: 'inv_ability_monk_renewingmists_active',
    maxRanks: 1,
    entryIds: [124861],
    definitionIds: [{ id: 129699, specId: 268 }],
  },
  OBSIDIAN_SPIRAL_TALENT: {
    id: 1249832,
    name: 'Obsidian Spiral',
    icon: 'ability_monk_spherediscord',
    maxRanks: 1,
    entryIds: [124823],
    definitionIds: [{ id: 129661, specId: 269 }],
  },
  ONE_VERSUS_MANY_TALENT: {
    id: 450988,
    name: 'One Versus Many',
    icon: 'ability_monk_chargingoxwave',
    maxRanks: 1,
    entryIds: [125071],
    definitionIds: [{ id: 129903, specId: 269 }],
  },
  ONE_WITH_THE_WIND_TALENT: {
    id: 454484,
    name: 'One With the Wind',
    icon: 'ability_skyreach_wind',
    maxRanks: 1,
    entryIds: [125611],
    definitionIds: [{ id: 130443, specId: 268 }],
  },
  OVERFLOWING_MISTS_TALENT: {
    id: 388511,
    name: 'Overflowing Mists',
    icon: 'inv_legion_faction_dreamweavers',
    maxRanks: 1,
    entryIds: [124872],
    definitionIds: [{ id: 129710, specId: 270 }],
  },
  OVERWHELMING_FORCE_TALENT: {
    id: 451024,
    name: 'Overwhelming Force',
    icon: 'ability_titankeeper_piercingcorruption',
    maxRanks: 1,
    entryIds: [125029],
    definitionIds: [{ id: 129865, specId: 270 }],
  },
  OX_STANCE_TALENT: {
    id: 455068,
    name: 'Ox Stance',
    icon: 'ability_monk_leeroftheox',
    maxRanks: 1,
    entryIds: [125004],
    definitionIds: [{ id: 129842, specId: 268 }],
  },
  PARALYSIS_TALENT: {
    id: 115078,
    name: 'Paralysis',
    icon: 'ability_monk_paralysis',
    maxRanks: 1,
    entryIds: [124932],
    definitionIds: [{ id: 129770, specId: 270 }],
    energyCost: 20,
  },
  PATH_OF_JADE_TALENT: {
    id: 392994,
    name: 'Path of Jade',
    icon: 'achievement_zone_jadeforest',
    maxRanks: 1,
    entryIds: [124816],
    definitionIds: [{ id: 129654, specId: 269 }],
  },
  PATH_OF_RESURGENCE_TALENT: {
    id: 450912,
    name: 'Path of Resurgence',
    icon: 'ability_monk_pathofmists',
    maxRanks: 1,
    entryIds: [125038],
    definitionIds: [{ id: 129874, specId: 270 }],
  },
  PATH_OF_THE_FALLING_STAR_TALENT: {
    id: 1273154,
    name: 'Path of the Falling Star',
    icon: 'ability_monk_chiswirl',
    maxRanks: 1,
    entryIds: [125050],
    definitionIds: [{ id: 129882, specId: 270 }],
  },
  PEACEFUL_MENDING_TALENT: {
    id: 388593,
    name: 'Peaceful Mending',
    icon: 'pandarenracial_innerpeace',
    maxRanks: 1,
    entryIds: [124898],
    definitionIds: [{ id: 129736, specId: 270 }],
  },
  PEACE_AND_PROSPERITY_TALENT: {
    id: 450448,
    name: 'Peace and Prosperity',
    icon: 'inv_inscription_deck_redcrane',
    maxRanks: 1,
    entryIds: [124957],
    definitionIds: [{ id: 129795, specId: 270 }],
  },
  POOL_OF_MISTS_TALENT: {
    id: 173841,
    name: 'Pool of Mists',
    icon: 'achievement_zone_sholazar_10',
    maxRanks: 1,
    entryIds: [125932],
    definitionIds: [{ id: 130763, specId: 270 }],
  },
  POTENTIAL_ENERGY_TALENT: {
    id: 1271048,
    name: 'Potential Energy',
    icon: 'spell_magic_managain',
    maxRanks: 1,
    entryIds: [135953],
    definitionIds: [{ id: 140708, specId: 270 }],
  },
  PREDICTIVE_TRAINING_TALENT: {
    id: 450992,
    name: 'Predictive Training',
    icon: 'ability_monk_domeofmist',
    maxRanks: 1,
    entryIds: [125064],
    definitionIds: [{ id: 129896, specId: 269 }],
  },
  PRESSURE_POINTS_TALENT: {
    id: 450432,
    name: 'Pressure Points',
    icon: 'ability_monk_deadlyreach',
    maxRanks: 1,
    entryIds: [124931],
    definitionIds: [{ id: 129769, specId: 270 }],
  },
  PRESS_THE_ADVANTAGE_TALENT: {
    id: 418359,
    name: 'Press the Advantage',
    icon: 'inv__fistofthewhitetiger',
    maxRanks: 1,
    entryIds: [124997],
    definitionIds: [{ id: 129835, specId: 268 }],
  },
  PRETENSE_OF_INSTABILITY_TALENT: {
    id: 393516,
    name: 'Pretense of Instability',
    icon: 'inv_misc_archaeology_vrykuldrinkinghorn',
    maxRanks: 1,
    entryIds: [125006],
    definitionIds: [{ id: 129844, specId: 268 }],
  },
  PRIDE_OF_PANDARIA_TALENT: {
    id: 450979,
    name: 'Pride of Pandaria',
    icon: 'inv_staff_2h_pandarenmonk_c_01',
    maxRanks: 1,
    entryIds: [125068],
    definitionIds: [{ id: 129900, specId: 269 }],
  },
  PROFOUND_REBUTTAL_TALENT: {
    id: 392910,
    name: 'Profound Rebuttal',
    icon: 'ability_monk_expelharm',
    maxRanks: 1,
    entryIds: [124923, 136513],
    definitionIds: [
      { id: 129761, specId: 268 },
      { id: 141286, specId: 269 },
    ],
  },
  PURIFIED_SPIRIT_TALENT: {
    id: 450867,
    name: 'Purified Spirit',
    icon: 'ability_monk_explodingjadeblossom',
    maxRanks: 1,
    entryIds: [125035],
    definitionIds: [{ id: 129871, specId: 270 }],
  },
  PURIFYING_BREW_TALENT: {
    id: 119582,
    name: 'Purifying Brew',
    icon: 'inv_misc_beer_06',
    maxRanks: 1,
    entryIds: [124838],
    definitionIds: [{ id: 129676, specId: 268 }],
  },
  QUICK_FOOTED_TALENT: {
    id: 450503,
    name: 'Quick Footed',
    icon: 'ability_monk_hurricanestrike',
    maxRanks: 1,
    entryIds: [124951],
    definitionIds: [{ id: 129789, specId: 270 }],
  },
  QUICK_SIP_TALENT: {
    id: 388505,
    name: 'Quick Sip',
    icon: 'achievement_faction_brewmaster',
    maxRanks: 1,
    entryIds: [136148],
    definitionIds: [{ id: 140903, specId: 268 }],
  },
  RAPID_DIFFUSION_TALENT: {
    id: 388847,
    name: 'Rapid Diffusion',
    icon: 'ability_monk_chiswirl',
    maxRanks: 2,
    entryIds: [124892],
    definitionIds: [{ id: 129730, specId: 270 }],
  },
  REFRESHMENT_TALENT: {
    id: 467270,
    name: 'Refreshment',
    icon: 'inv_misc_gem_pearl_06',
    maxRanks: 1,
    entryIds: [124873],
    definitionIds: [{ id: 129711, specId: 270 }],
  },
  REINVIGORATION_TALENT: {
    id: 1266740,
    name: 'Reinvigoration',
    icon: 'ability_monk_quipunch',
    maxRanks: 1,
    entryIds: [136520],
    definitionIds: [{ id: 141293, specId: 270 }],
  },
  RESPLENDENT_MIST_TALENT: {
    id: 388020,
    name: 'Resplendent Mist',
    icon: 'spell_nature_abolishmagic',
    maxRanks: 2,
    entryIds: [124911],
    definitionIds: [{ id: 129749, specId: 270 }],
  },
  RESTORAL_TALENT: {
    id: 388615,
    name: 'Restoral',
    icon: 'ability_monk_tigerstyle',
    maxRanks: 1,
    entryIds: [124918],
    definitionIds: [{ id: 129756, specId: 270 }],
    manaCost: 10935,
  },
  RESTORE_BALANCE_TALENT: {
    id: 442719,
    name: 'Restore Balance',
    icon: 'ability_monk_chiexplosion',
    maxRanks: 1,
    entryIds: [136760, 125049],
    definitionIds: [
      { id: 141531, specId: 269 },
      { id: 129881, specId: 270 },
    ],
  },
  REVIVAL_TALENT: {
    id: 115310,
    name: 'Revival',
    icon: 'spell_monk_revival',
    maxRanks: 1,
    entryIds: [124919],
    definitionIds: [{ id: 129757, specId: 270 }],
    manaCost: 10935,
  },
  REVOLVING_WHIRL_TALENT: {
    id: 451524,
    name: 'Revolving Whirl',
    icon: 'ability_monk_chiswirl',
    maxRanks: 1,
    entryIds: [125010],
    definitionIds: [{ id: 129848, specId: 269 }],
  },
  RING_OF_PEACE_TALENT: {
    id: 116844,
    name: 'Ring of Peace',
    icon: 'spell_monk_ringofpeace',
    maxRanks: 1,
    entryIds: [124926],
    definitionIds: [{ id: 129764, specId: 270 }],
  },
  RISING_MIST_TALENT: {
    id: 274909,
    name: 'Rising Mist',
    icon: 'ability_monk_effuse',
    maxRanks: 1,
    entryIds: [124899],
    definitionIds: [{ id: 129737, specId: 270 }],
  },
  RISING_STAR_TALENT: {
    id: 388849,
    name: 'Rising Star',
    icon: 'ability_monk_risingsunkick',
    maxRanks: 1,
    entryIds: [125012],
    definitionIds: [{ id: 129850, specId: 269 }],
  },
  RISING_SUN_KICK_TALENT: {
    id: 107428,
    name: 'Rising Sun Kick',
    icon: 'ability_monk_risingsunkick',
    maxRanks: 1,
    entryIds: [124985],
    definitionIds: [{ id: 129823, specId: 270 }],
    chiCost: 2,
    manaCost: 6250,
  },
  ROAR_FROM_THE_HEAVENS_TALENT: {
    id: 451043,
    name: 'Roar from the Heavens',
    icon: 'inv_celestialserpentmount',
    maxRanks: 1,
    entryIds: [125030],
    definitionIds: [{ id: 129866, specId: 270 }],
  },
  RUSHING_JADE_WIND_TALENT: {
    id: 116847,
    name: 'Rushing Jade Wind',
    icon: 'ability_monk_rushingjadewind',
    maxRanks: 1,
    entryIds: [125007],
    definitionIds: [{ id: 129845, specId: 268 }],
    chiCost: 1,
  },
  RUSHING_REFLEXES_TALENT: {
    id: 450154,
    name: 'Rushing Reflexes',
    icon: 'ability_monk_yulonsgift',
    maxRanks: 1,
    entryIds: [124946],
    definitionIds: [{ id: 129784, specId: 270 }],
  },
  RUSHING_WIND_KICK_MISTWEAVER_TALENT: {
    id: 467307,
    name: 'Rushing Wind Kick',
    icon: 'inv12_ability_monk_rushingwindkick',
    maxRanks: 1,
    entryIds: [128221],
    definitionIds: [{ id: 133028, specId: 270 }],
    manaCost: 3125,
    chiCost: 2,
  },
  RUSHING_WIND_KICK_WINDWALKER_TALENT: {
    id: 1250566,
    name: 'Rushing Wind Kick',
    icon: 'inv12_ability_monk_rushingwindkick',
    maxRanks: 1,
    entryIds: [134543],
    definitionIds: [{ id: 139311, specId: 269 }],
  },
  SALSALABIMS_STRENGTH_TALENT: {
    id: 383697,
    name: "Sal'salabim's Strength",
    icon: 'ability_warrior_unrelentingassault',
    maxRanks: 1,
    entryIds: [124988],
    definitionIds: [{ id: 129826, specId: 268 }],
  },
  SAVE_THEM_ALL_TALENT: {
    id: 389579,
    name: 'Save Them All',
    icon: 'inv_weapon_hand_22',
    maxRanks: 1,
    entryIds: [124949],
    definitionIds: [{ id: 129787, specId: 270 }],
  },
  SCALDING_BREW_TALENT: {
    id: 383698,
    name: 'Scalding Brew',
    icon: 'spell_brew_bolt_dark',
    maxRanks: 1,
    entryIds: [124989],
    definitionIds: [{ id: 129827, specId: 268 }],
  },
  SECRET_INFUSION_TALENT: {
    id: 388491,
    name: 'Secret Infusion',
    icon: 'ability_monk_chibrew',
    maxRanks: 2,
    entryIds: [124908],
    definitionIds: [{ id: 129746, specId: 270 }],
  },
  SEQUENCED_STRIKES_TALENT: {
    id: 451515,
    name: 'Sequenced Strikes',
    icon: 'ability_monk_sparring',
    maxRanks: 1,
    entryIds: [124833],
    definitionIds: [{ id: 129671, specId: 269 }],
  },
  SERENE_SURGE_TALENT: {
    id: 1266734,
    name: 'Serene Surge',
    icon: 'ability_monk_surgingmist',
    maxRanks: 1,
    entryIds: [136516],
    definitionIds: [{ id: 141289, specId: 270 }],
  },
  SHADOWBOXING_TREADS_BREWMASTER_TALENT: {
    id: 387638,
    name: 'Shadowboxing Treads',
    icon: 'ability_monk_roundhousekick',
    maxRanks: 1,
    entryIds: [124853],
    definitionIds: [{ id: 129691, specId: 268 }],
  },
  SHADOWBOXING_TREADS_WINDWALKER_TALENT: {
    id: 392982,
    name: 'Shadowboxing Treads',
    icon: 'ability_monk_roundhousekick',
    maxRanks: 1,
    entryIds: [124836],
    definitionIds: [{ id: 129674, specId: 269 }],
  },
  SHADO_OVER_THE_BATTLEFIELD_TALENT: {
    id: 1262612,
    name: 'Shado Over the Battlefield',
    icon: 'inv_elemental_primal_shadow',
    maxRanks: 1,
    entryIds: [135955],
    definitionIds: [{ id: 140710, specId: 269 }],
  },
  SHARP_REFLEXES_TALENT: {
    id: 261917,
    name: 'Sharp Reflexes',
    icon: 'ability_monk_roundhousekick',
    maxRanks: 1,
    entryIds: [124806],
    definitionIds: [{ id: 129644, specId: 269 }],
  },
  SHEILUNS_GIFT_TALENT: {
    id: 399491,
    name: "Sheilun's Gift",
    icon: 'inv12_ability_monk_sheilunsgift',
    maxRanks: 1,
    entryIds: [124904],
    definitionIds: [{ id: 129742, specId: 270 }],
    manaCost: 7500,
  },
  SHUFFLE_TALENT: {
    id: 322120,
    name: 'Shuffle',
    icon: 'ability_monk_shuffle',
    maxRanks: 1,
    entryIds: [124864],
    definitionIds: [{ id: 129702, specId: 268 }],
  },
  SILENT_SANCTUARY_TALENT: {
    id: 1266719,
    name: 'Silent Sanctuary',
    icon: 'spell_monk_zenpilgrimage',
    maxRanks: 1,
    entryIds: [136517],
    definitionIds: [{ id: 141290, specId: 270 }],
  },
  SINGULARLY_FOCUSED_JADE_TALENT: {
    id: 451573,
    name: 'Singularly Focused Jade',
    icon: 'ability_monk_fortuneturned',
    maxRanks: 1,
    entryIds: [126026],
    definitionIds: [{ id: 130858, specId: 269 }],
  },
  SKYFIRE_HEEL_TALENT: {
    id: 1248704,
    name: 'Skyfire Heel',
    icon: 'inv_1115_warrior_kick',
    maxRanks: 1,
    entryIds: [128711],
    definitionIds: [{ id: 133513, specId: 269 }],
  },
  SLICING_WINDS_TALENT: {
    id: 1217413,
    name: 'Slicing Winds',
    icon: 'ability_skyreach_wind_wall',
    maxRanks: 1,
    entryIds: [126307],
    definitionIds: [{ id: 131133, specId: 269 }],
    chiCost: 2,
  },
  SONG_OF_CHI_JI_TALENT: {
    id: 198898,
    name: 'Song of Chi-Ji',
    icon: 'inv_chaos_orb',
    maxRanks: 1,
    entryIds: [124925],
    definitionIds: [{ id: 129763, specId: 270 }],
  },
  SOOTHING_MIST_TALENT: {
    id: 115175,
    name: 'Soothing Mist',
    icon: 'ability_monk_soothingmists',
    maxRanks: 1,
    entryIds: [124933],
    definitionIds: [{ id: 129771, specId: 270 }],
    manaCostPerSecond: 1000,
    energyCostPerSecond: 15,
  },
  SPEAR_HAND_STRIKE_TALENT: {
    id: 116705,
    name: 'Spear Hand Strike',
    icon: 'ability_monk_spearhand',
    maxRanks: 1,
    entryIds: [124943, 136599],
    definitionIds: [
      { id: 129781, specId: 268 },
      { id: 141372, specId: 269 },
    ],
  },
  SPECIAL_DELIVERY_TALENT: {
    id: 196730,
    name: 'Special Delivery',
    icon: 'achievement_brewery_2',
    maxRanks: 1,
    entryIds: [125008],
    definitionIds: [{ id: 129846, specId: 268 }],
  },
  SPIRITFONT_1_MISTWEAVER_TALENT: {
    id: 1260511,
    name: 'Spiritfont',
    icon: 'inv12_apextalent_monk_spiritfont',
    maxRanks: 1,
    entryIds: [135749],
    definitionIds: [{ id: 140504, specId: 270 }],
  },
  SPIRITFONT_2_MISTWEAVER_TALENT: {
    id: 1260677,
    name: 'Spiritfont',
    icon: 'inv12_apextalent_monk_spiritfont',
    maxRanks: 2,
    entryIds: [137072],
    definitionIds: [{ id: 141836, specId: 270 }],
  },
  SPIRITFONT_3_MISTWEAVER_TALENT: {
    id: 1260680,
    name: 'Spiritfont',
    icon: 'inv12_apextalent_monk_spiritfont',
    maxRanks: 1,
    entryIds: [137071],
    definitionIds: [{ id: 141835, specId: 270 }],
  },
  SPIRITS_ESSENCE_TALENT: {
    id: 450595,
    name: "Spirit's Essence",
    icon: 'spell_shaman_spectraltransformation',
    maxRanks: 1,
    entryIds: [124928],
    definitionIds: [{ id: 129766, specId: 270 }],
  },
  SPIRITUAL_FOCUS_TALENT: {
    id: 280197,
    name: 'Spiritual Focus',
    icon: 'spell_nature_giftofthewild',
    maxRanks: 1,
    entryIds: [124824],
    definitionIds: [{ id: 129662, specId: 269 }],
  },
  SPIRIT_OF_THE_OX_TALENT: {
    id: 400629,
    name: 'Spirit of the Ox',
    icon: 'ability_titankeeper_cleansingorb',
    maxRanks: 1,
    entryIds: [124863],
    definitionIds: [{ id: 129701, specId: 268 }],
  },
  STAGGERING_STRIKES_TALENT: {
    id: 387625,
    name: 'Staggering Strikes',
    icon: 'ability_monk_blackoutstrike',
    maxRanks: 1,
    entryIds: [124839],
    definitionIds: [{ id: 129677, specId: 268 }],
  },
  STAGGER_TALENT: {
    id: 115069,
    name: 'Stagger',
    icon: 'monk_stance_drunkenox',
    maxRanks: 1,
    entryIds: [136086],
    definitionIds: [{ id: 140841, specId: 268 }],
  },
  STAMPEDE_OF_THE_ANCIENTS_TALENT: {
    id: 1262756,
    name: 'Stampede of the Ancients',
    icon: 'monk_ability_summonoxstatue',
    maxRanks: 1,
    entryIds: [125059],
    definitionIds: [{ id: 129891, specId: 270 }],
  },
  STAND_READY_TALENT: {
    id: 1262603,
    name: 'Stand Ready',
    icon: 'ability_monk_sparring',
    maxRanks: 1,
    entryIds: [135956],
    definitionIds: [{ id: 140711, specId: 269 }],
  },
  STILLSTEP_COIL_TALENT: {
    id: 1266733,
    name: 'Stillstep Coil',
    icon: 'inv_helm_leather_raidmonkprogenitormythic_d_01',
    maxRanks: 1,
    entryIds: [136518],
    definitionIds: [{ id: 141291, specId: 270 }],
  },
  STORMSTOUTS_LAST_KEG_TALENT: {
    id: 383707,
    name: "Stormstout's Last Keg",
    icon: 'achievement_brewery_2',
    maxRanks: 1,
    entryIds: [124999],
    definitionIds: [{ id: 129837, specId: 268 }],
  },
  STRENGTH_OF_SPIRIT_TALENT: {
    id: 387276,
    name: 'Strength of Spirit',
    icon: 'ability_monk_healthsphere',
    maxRanks: 1,
    entryIds: [124924, 136514],
    definitionIds: [
      { id: 129762, specId: 268 },
      { id: 141287, specId: 269 },
    ],
  },
  STRENGTH_OF_THE_BLACK_OX_TALENT: {
    id: 443110,
    name: 'Strength of the Black Ox',
    icon: 'ability_monk_chargingoxwave',
    maxRanks: 1,
    entryIds: [136747],
    definitionIds: [{ id: 141519, specId: 270 }],
  },
  STRIKE_OF_THE_WINDLORD_TALENT: {
    id: 392983,
    name: 'Strike of the Windlord',
    icon: 'inv_hand_1h_artifactskywall_d_01',
    maxRanks: 1,
    entryIds: [125014],
    definitionIds: [{ id: 129852, specId: 269 }],
    chiCost: 2,
  },
  SUMMON_BLACK_OX_STATUE_TALENT: {
    id: 115315,
    name: 'Summon Black Ox Statue',
    icon: 'monk_ability_summonoxstatue',
    maxRanks: 1,
    entryIds: [124967],
    definitionIds: [{ id: 129805, specId: 268 }],
  },
  SUMMON_JADE_SERPENT_STATUE_TALENT: {
    id: 115313,
    name: 'Summon Jade Serpent Statue',
    icon: 'ability_monk_summonserpentstatue',
    maxRanks: 1,
    entryIds: [133997],
    definitionIds: [{ id: 138783, specId: 270 }],
  },
  SUNFIRE_SPIRAL_TALENT: {
    id: 1272415,
    name: 'Sunfire Spiral',
    icon: 'inv_helm_suncrown_d_01',
    maxRanks: 1,
    entryIds: [125020],
    definitionIds: [{ id: 129858, specId: 269 }],
  },
  SWIFT_ART_TALENT: {
    id: 450622,
    name: 'Swift Art',
    icon: 'ability_monk_standingkick',
    maxRanks: 1,
    entryIds: [124947],
    definitionIds: [{ id: 129785, specId: 270 }],
  },
  SWIFT_AS_A_COURSING_RIVER_TALENT: {
    id: 1263346,
    name: 'Swift as a Coursing River',
    icon: 'ability_rogue_sprint_blue',
    maxRanks: 1,
    entryIds: [124837],
    definitionIds: [{ id: 129675, specId: 268 }],
  },
  TEACHINGS_OF_THE_MONASTERY_TALENT: {
    id: 116645,
    name: 'Teachings of the Monastery',
    icon: 'passive_monk_teachingsofmonastery',
    maxRanks: 1,
    entryIds: [124827],
    definitionIds: [{ id: 129665, specId: 269 }],
  },
  TEAR_OF_MORNING_TALENT: {
    id: 387991,
    name: 'Tear of Morning',
    icon: 'ability_monk_uplift',
    maxRanks: 1,
    entryIds: [124900],
    definitionIds: [{ id: 129738, specId: 270 }],
  },
  TEMPLE_TRAINING_TALENT: {
    id: 442743,
    name: 'Temple Training',
    icon: 'ability_monk_provoke',
    maxRanks: 1,
    entryIds: [125054],
    definitionIds: [{ id: 129886, specId: 270 }],
  },
  THUNDERFIST_TALENT: {
    id: 392985,
    name: 'Thunderfist',
    icon: 'inv_hand_1h_artifactskywall_d_01',
    maxRanks: 1,
    entryIds: [124811],
    definitionIds: [{ id: 129649, specId: 269 }],
  },
  THUNDER_FOCUS_TEA_TALENT: {
    id: 116680,
    name: 'Thunder Focus Tea',
    icon: 'ability_monk_thunderfocustea',
    maxRanks: 1,
    entryIds: [124921],
    definitionIds: [{ id: 129759, specId: 270 }],
  },
  TIGEREYE_BREW_1_WINDWALKER_TALENT: {
    id: 1261703,
    name: 'Tigereye Brew',
    icon: 'inv12_apextalent_monk_tigereyebrew',
    maxRanks: 1,
    entryIds: [137076],
    definitionIds: [{ id: 141840, specId: 269 }],
  },
  TIGEREYE_BREW_2_WINDWALKER_TALENT: {
    id: 1261844,
    name: 'Tigereye Brew',
    icon: 'inv12_apextalent_monk_tigereyebrew',
    maxRanks: 2,
    entryIds: [137077],
    definitionIds: [{ id: 141841, specId: 269 }],
  },
  TIGEREYE_BREW_3_WINDWALKER_TALENT: {
    id: 1261849,
    name: 'Tigereye Brew',
    icon: 'inv12_apextalent_monk_tigereyebrew',
    maxRanks: 1,
    entryIds: [137078],
    definitionIds: [{ id: 141842, specId: 269 }],
  },
  TIGERS_LUST_TALENT: {
    id: 116841,
    name: "Tiger's Lust",
    icon: 'ability_monk_tigerslust',
    maxRanks: 1,
    entryIds: [124937],
    definitionIds: [{ id: 129775, specId: 270 }],
  },
  TIGERS_VIGOR_TALENT: {
    id: 451041,
    name: "Tiger's Vigor",
    icon: 'monk_stance_whitetiger',
    maxRanks: 1,
    entryIds: [125031],
    definitionIds: [{ id: 129867, specId: 270 }],
  },
  TIGER_FANG_TALENT: {
    id: 1272781,
    name: 'Tiger Fang',
    icon: 'ability_mount_siberiantigermount',
    maxRanks: 1,
    entryIds: [124953],
    definitionIds: [{ id: 129791, specId: 269 }],
  },
  TIGER_TAIL_SWEEP_TALENT: {
    id: 264348,
    name: 'Tiger Tail Sweep',
    icon: 'ability_monk_legsweep',
    maxRanks: 1,
    entryIds: [124980],
    definitionIds: [{ id: 129818, specId: 270 }],
  },
  TOUCH_OF_THE_TIGER_TALENT: {
    id: 388856,
    name: 'Touch of the Tiger',
    icon: 'ability_monk_tigerpalm',
    maxRanks: 1,
    entryIds: [124821],
    definitionIds: [{ id: 129659, specId: 269 }],
  },
  TRAINING_OF_NIUZAO_TALENT: {
    id: 383714,
    name: 'Training of Niuzao',
    icon: 'monk_stance_drunkenox',
    maxRanks: 1,
    entryIds: [124857],
    definitionIds: [{ id: 129695, specId: 268 }],
  },
  TRANQUIL_SPIRIT_TALENT: {
    id: 393357,
    name: 'Tranquil Spirit',
    icon: 'ability_monk_chiswirl',
    maxRanks: 1,
    entryIds: [124860],
    definitionIds: [{ id: 129698, specId: 268 }],
  },
  TRANQUIL_TEA_TALENT: {
    id: 1270621,
    name: 'Tranquil Tea',
    icon: 'inv_misc_pearlmilktea',
    maxRanks: 1,
    entryIds: [124902],
    definitionIds: [{ id: 129740, specId: 270 }],
  },
  TRANSCENDENCE_LINKED_SPIRITS_TALENT: {
    id: 434774,
    name: 'Transcendence: Linked Spirits',
    icon: 'monk_ability_transcendence',
    maxRanks: 1,
    entryIds: [124972],
    definitionIds: [{ id: 129810, specId: 270 }],
  },
  TRANSCENDENCE_TALENT: {
    id: 101643,
    name: 'Transcendence',
    icon: 'monk_ability_transcendence',
    maxRanks: 1,
    entryIds: [124962],
    definitionIds: [{ id: 129800, specId: 270 }],
  },
  UNITY_WITHIN_TALENT: {
    id: 443589,
    name: 'Unity Within',
    icon: 'ability_monk_prideofthetiger',
    maxRanks: 1,
    entryIds: [125058],
    definitionIds: [{ id: 129890, specId: 270 }],
  },
  UNIVERSAL_ENERGY_TALENT: {
    id: 1272175,
    name: 'Universal Energy',
    icon: 'ability_monk_chiswirl',
    maxRanks: 1,
    entryIds: [124818],
    definitionIds: [{ id: 129656, specId: 269 }],
  },
  UPLIFTED_SPIRITS_TALENT: {
    id: 388551,
    name: 'Uplifted Spirits',
    icon: 'inv_helm_leather_raidmonkgoblin_d_01',
    maxRanks: 1,
    entryIds: [124869],
    definitionIds: [{ id: 129707, specId: 270 }],
  },
  VEIL_OF_PRIDE_TALENT: {
    id: 400053,
    name: 'Veil of Pride',
    icon: 'ability_monk_vivify',
    maxRanks: 1,
    entryIds: [124903],
    definitionIds: [{ id: 129741, specId: 270 }],
  },
  VETERANS_EYE_TALENT: {
    id: 450987,
    name: "Veteran's Eye",
    icon: 'ability_monk_provoke',
    maxRanks: 1,
    entryIds: [125070],
    definitionIds: [{ id: 129902, specId: 269 }],
  },
  VIGILANT_WATCH_TALENT: {
    id: 450993,
    name: 'Vigilant Watch',
    icon: 'ability_rogue_masterofsubtlety',
    maxRanks: 1,
    entryIds: [125063],
    definitionIds: [{ id: 129895, specId: 269 }],
  },
  VIGOROUS_EXPULSION_TALENT: {
    id: 392900,
    name: 'Vigorous Expulsion',
    icon: 'ability_monk_expelharm',
    maxRanks: 1,
    entryIds: [124948, 136511],
    definitionIds: [
      { id: 129786, specId: 268 },
      { id: 141284, specId: 269 },
    ],
  },
  VITAL_CLARITY_TALENT: {
    id: 1266748,
    name: 'Vital Clarity',
    icon: 'ability_monk_souldance',
    maxRanks: 1,
    entryIds: [136512],
    definitionIds: [{ id: 141285, specId: 270 }],
  },
  VITAL_FLAME_TALENT: {
    id: 1262659,
    name: 'Vital Flame',
    icon: 'achievement_faction_shadopan',
    maxRanks: 1,
    entryIds: [136149],
    definitionIds: [{ id: 140904, specId: 268 }],
  },
  VIVACIOUS_VIVIFICATION_TALENT: {
    id: 388812,
    name: 'Vivacious Vivification',
    icon: 'ability_monk_vivify',
    maxRanks: 1,
    entryIds: [124935, 136515, 136519],
    definitionIds: [
      { id: 129773, specId: 268 },
      { id: 141288, specId: 269 },
      { id: 141292, specId: 270 },
    ],
  },
  WALK_WITH_THE_OX_TALENT: {
    id: 387219,
    name: 'Walk with the Ox',
    icon: 'ability_monk_chargingoxwave',
    maxRanks: 2,
    entryIds: [124848],
    definitionIds: [{ id: 129686, specId: 268 }],
  },
  WAY_OF_A_THOUSAND_STRIKES_TALENT: {
    id: 450965,
    name: 'Way of a Thousand Strikes',
    icon: 'ability_monk_mightyoxkick',
    maxRanks: 1,
    entryIds: [125037],
    definitionIds: [{ id: 129873, specId: 270 }],
  },
  WAY_OF_THE_CRANE_TALENT: {
    id: 388779,
    name: 'Way of the Crane',
    icon: 'monk_stance_redcrane',
    maxRanks: 1,
    entryIds: [134001],
    definitionIds: [{ id: 138787, specId: 270 }],
  },
  WAY_OF_THE_SERPENT_TALENT: {
    id: 1243155,
    name: 'Way of the Serpent',
    icon: 'monk_stance_wiseserpent',
    maxRanks: 1,
    entryIds: [124885],
    definitionIds: [{ id: 129723, specId: 270 }],
  },
  WEAPONS_OF_THE_WALL_TALENT: {
    id: 1262610,
    name: 'Weapons of the Wall',
    icon: 'misc_legionfall_monk',
    maxRanks: 1,
    entryIds: [135957],
    definitionIds: [{ id: 140712, specId: 269 }],
  },
  WEAPON_OF_WIND_TALENT: {
    id: 1272678,
    name: 'Weapon of Wind',
    icon: 'inv_tradeskillitem_sorcererswind_tong',
    maxRanks: 1,
    entryIds: [125013],
    definitionIds: [{ id: 129851, specId: 269 }],
  },
  WHIRLING_DRAGON_PUNCH_TALENT: {
    id: 152175,
    name: 'Whirling Dragon Punch',
    icon: 'ability_monk_hurricanestrike',
    maxRanks: 1,
    entryIds: [134452],
    definitionIds: [{ id: 139223, specId: 269 }],
  },
  WHIRLING_STEEL_TALENT: {
    id: 450991,
    name: 'Whirling Steel',
    icon: 'ability_whirlwind',
    maxRanks: 1,
    entryIds: [125065],
    definitionIds: [{ id: 129897, specId: 269 }],
  },
  WINDS_REACH_TALENT: {
    id: 450514,
    name: "Wind's Reach",
    icon: 'ability_monk_zenflight',
    maxRanks: 1,
    entryIds: [124938],
    definitionIds: [{ id: 129776, specId: 270 }],
  },
  WINDWALKING_TALENT: {
    id: 157411,
    name: 'Windwalking',
    icon: 'monk_stance_whitetiger',
    maxRanks: 1,
    entryIds: [124971],
    definitionIds: [{ id: 129809, specId: 270 }],
  },
  WISDOM_OF_THE_WALL_TALENT: {
    id: 1272821,
    name: 'Wisdom of the Wall',
    icon: 'inv_legendary_sigilofwisdom',
    maxRanks: 1,
    entryIds: [125073],
    definitionIds: [{ id: 129905, specId: 269 }],
  },
  XUENS_BATTLEGEAR_TALENT: {
    id: 392993,
    name: "Xuen's Battlegear",
    icon: 'monk_stance_whitetiger',
    maxRanks: 1,
    entryIds: [125017],
    definitionIds: [{ id: 129855, specId: 269 }],
  },
  XUENS_BOND_TALENT: {
    id: 392986,
    name: "Xuen's Bond",
    icon: 'ability_demonhunter_netherbond',
    maxRanks: 1,
    entryIds: [136744],
    definitionIds: [{ id: 141516, specId: 269 }],
  },
  XUENS_GUIDANCE_TALENT: {
    id: 442687,
    name: "Xuen's Guidance",
    icon: 'ability_monk_dpsstance',
    maxRanks: 1,
    entryIds: [125053],
    definitionIds: [{ id: 129885, specId: 270 }],
  },
  YULONS_AVATAR_TALENT: {
    id: 1262667,
    name: "Yu'lon's Avatar",
    icon: 'inv_celestialserpentmount_jade',
    maxRanks: 1,
    entryIds: [136754],
    definitionIds: [{ id: 141526, specId: 270 }],
  },
  YULONS_GRACE_TALENT: {
    id: 414131,
    name: "Yu'lon's Grace",
    icon: 'ability_monk_dragonkick',
    maxRanks: 1,
    entryIds: [124960],
    definitionIds: [{ id: 129798, specId: 270 }],
  },
  YULONS_KNOWLEDGE_TALENT: {
    id: 443625,
    name: "Yu'lon's Knowledge",
    icon: 'inv_jewelcrafting_jadeserpent',
    maxRanks: 1,
    entryIds: [125048],
    definitionIds: [{ id: 129880, specId: 270 }],
  },
  YULONS_WHISPER_TALENT: {
    id: 388038,
    name: "Yu'lon's Whisper",
    icon: 'ability_monk_chiexplosion',
    maxRanks: 1,
    entryIds: [124880],
    definitionIds: [{ id: 129718, specId: 270 }],
  },
  ZENITH_STOMP_TALENT: {
    id: 1272694,
    name: 'Zenith Stomp',
    icon: 'inv_ability_monk_jadefirestomp',
    maxRanks: 1,
    entryIds: [124956],
    definitionIds: [{ id: 129794, specId: 269 }],
  },
  ZENITH_TALENT: {
    id: 1249625,
    name: 'Zenith',
    icon: 'inv_ability_monk_weaponsoforder',
    maxRanks: 1,
    entryIds: [124826],
    definitionIds: [{ id: 129664, specId: 269 }],
  },
  ZEN_PULSE_TALENT: {
    id: 446326,
    name: 'Zen Pulse',
    icon: 'ability_monk_forcesphere',
    maxRanks: 1,
    entryIds: [124889],
    definitionIds: [{ id: 129727, specId: 270 }],
  },
  ZEN_STATE_TALENT: {
    id: 1241136,
    name: 'Zen State',
    icon: 'spell_monk_zenpilgrimage',
    maxRanks: 1,
    entryIds: [124851],
    definitionIds: [{ id: 129689, specId: 268 }],
  },
} satisfies Record<string, Talent>;

export default talents;
export { talents as TALENTS_MONK };
